// Imports
import Axios from 'axios'
import { useLocalBackend, localBackend } from '@/api/config/localBackend'

// Development only: the local Lens server, proxied on this origin
const serverUrl = useLocalBackend
  ? localBackend.lensUrl
  : process.env.VUE_APP_LENS_SERVER_ENV === 'staging' ? 'https://dev.api.lens.foreplay.co' : 'https://api.lens.foreplay.co'
// Axios Config
const AxiosConfig = Axios.create({
  // baseURL: 'http://localhost:3000'
  baseURL: serverUrl
})

export default AxiosConfig
